(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs-advanced"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(e){

  if(!e.target.matches('.tab-btn')) return;

  const section = e.target.closest('.product-tabs-advanced');
  if(!section) return;

  section.querySelectorAll('.tab-btn').forEach(btn => btn.classList.remove('active'));
  section.querySelectorAll('.tab-pane').forEach(pane => pane.classList.remove('active'));

  e.target.classList.add('active');
  const tabId = e.target.dataset.tab;
  section.querySelector('#' + tabId).classList.add('active');

});

  } catch(e) { console.error(e); }
})();
})();
